module.exports = __webpack_public_path__ + "img/wx／pic.3ed56881.png";